import {Component, OnInit} from '@angular/core';
import {BaseService} from "../../services/base.service";
import {Meta, Title} from "@angular/platform-browser";
import {LocalStorageService} from "../../services/local-storage.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-basket-confirm',
  templateUrl: './basket-confirm.component.html',
  styleUrls: ['./basket-confirm.component.scss'],
})
export class BasketConfirmComponent extends BaseService implements OnInit {
  isDestroyed: Subject<boolean> = new Subject();
  delivery;

  constructor(
    private titleService: Title,
    private meta: Meta,
    private localStorage: LocalStorageService,
    private http: HttpClient
  ) {
    super();

    const title = "Маслоточка | Кошик | Оформлення замовлення";

    this.titleService.setTitle(title);
    this.meta.addTag({name: 'title', content: title});
  }

  ngOnInit() {
    this.delivery = parseInt(this.localStorage.get('delivery_id'));
  }

  setDelivery(id: number) {
    const deliveryChanged = id !== this.delivery;

    this.localStorage.set('delivery_id', id);

    // Екран доставки читає delivery_id і тягне дані (дати, години, адресу) лише при
    // створенні. Доставки 1/31+ і 3/11 обслуговує той самий компонент - без
    // перестворення він лишався на старій доставці і замовлення йшло з нею.
    this.delivery = null;

    if (!deliveryChanged) {
      setTimeout(() => this.delivery = id);
      return;
    }

    // «Відвантажити різними» клієнт обирав у кошику під попередню доставку: чи можна ділити,
    // залежить від доставки (allow_separate_orders). Після зміни доставки прапорець скидаємо -
    // замовлення піде одним, «різними» для нової доставки можна обрати в кошику (#577).
    // Бек у pay() теж перевіряє - це на випадок зміни доставки в обхід цієї сторінки.
    // Екран доставки створюємо після відповіді: дати він має читати вже без розділення
    // (бек при скиданні чистить кеш дат). Показуємо і при помилці, і коли інтерцептор
    // завершив запит без відповіді (скасування, редирект) - інакше сторінка лишиться порожня.
    const showDelivery = () => this.delivery = id;
    this.http.post(this.apiRoot + 'basket_data/setup_session_separate_orders', {value: 0})
      .subscribe({complete: showDelivery, error: showDelivery});
  }
}
